import React, { useEffect, useRef } from "react";
import { FaQuoteLeft, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const PrincipalMessage = () => {
  const sectionRef = useRef(null);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fade-up");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    if (cardRef.current) observer.observe(cardRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-8 px-4 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-indigo-500/5 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="w-full px-4 md:px-8" ref={sectionRef}>
        <div className="text-center mb-8 animate-fade-in">
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            <span className="bg-gradient-to-r from-blue-600 via-indigo-500 to-blue-600 bg-clip-text text-transparent animate-gradient">
              Principal's Message
            </span>
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            A word from our respected Principal
          </p>
        </div>

        <div
          ref={cardRef}
          className="group opacity-0 transition-all duration-700 transform translate-y-8 hover:-translate-y-1 hover:shadow-xl rounded-2xl shadow-md overflow-hidden bg-gradient-to-br from-blue-50 via-white to-indigo-50 border-t-4 border-blue-500"
        >
          <div className="flex flex-col md:flex-row">
            <div className="md:w-1/3 p-6 bg-white/40 backdrop-blur-sm flex flex-col items-center text-center border-b md:border-b-0 md:border-r border-gray-100">
              <div className="w-40 h-40 md:w-56 md:h-56 rounded-full overflow-hidden bg-gradient-to-br from-blue-100 to-indigo-100 shadow-md mb-4">
                <img
                  src="/sourabh.png"
                  alt="Dr. Sourabh Parmar, Principal RDS College of Pharmacy"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-800">Dr. Sourabh Parmar</h3>
              <p className="text-blue-600 font-semibold text-base">Principal</p>
              <p className="text-gray-500 text-sm mb-4">RDS College of Pharmacy</p>
              <div className="flex justify-center gap-6 w-full mt-2">
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600">15+</div>
                  <div className="text-xs text-gray-500">Years Exp.</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-indigo-600">PhD</div>
                  <div className="text-xs text-gray-500">Qualification</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600">20+</div>
                  <div className="text-xs text-gray-500">Publications</div>
                </div>
              </div>
              <div className="mt-6 pt-4 border-t border-gray-200 w-full text-left">
                <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
                  <FaEnvelope className="text-blue-500" />
                  <a href="mailto:principal@rdspharmacy.edu.in" className="hover:text-blue-600 transition">
                    principal@rdspharmacy.edu.in
                  </a>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <FaPhoneAlt className="text-blue-500" />
                  <a href="tel:+91+91 7784041372" className="hover:text-blue-600 transition">
                   +91 7784041372
                  </a>
                </div>
              </div>
            </div>

            {/* Right Column - Message */}
            <div className="md:w-2/3 p-6">
              <div className="flex items-start gap-2 mb-3">
                <FaQuoteLeft className="text-2xl text-blue-500 opacity-60" />
                <h3 className="text-lg font-semibold text-gray-800">A Word from Our Principal</h3>
              </div>
              <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
                <p>
                  The era in which new generation is growing is far challenging than what we have left behind.
                  Education should result in emergence of a personality which not only make one capable of
                  looking after themselves but makes one a good citizen who can builds the world into a better
                  place to live. Every mind dreams of achieving its desired goal of life, which is possible only
                  with adequate knowledge and professionalism. We are here to find your steps from{" "}
                  <strong>"where you are"</strong> to <strong>"what you can become"</strong>.
                </p>
                <p className="italic text-blue-700">
                  "You will definitely enjoy the journey to actualize our shared dream and to dream new."
                </p>
                <p>
                  On behalf of the entire RDS College of Pharmacy fraternity, I welcome you to our institution.
                  Here you will find a dynamic, friendly and disciplined atmosphere to{" "}
                  <strong>"learn to serve"</strong> the society. Highly qualified, enthusiastic and dedicated
                  teaching staff will be with you to transform your dream into reality.
                </p>
                <p>
                  We are committed to build the college as 'center of Excellence' with best infrastructure,
                  innovative teaching-learning process and best learning resources. I hope you spend the most
                  amazing and memorable years of your life in our institute.
                </p>
                <p className="font-semibold text-blue-700 pt-2">WELCOME TO RDS COLLEGE OF PHARMACY!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes fade-up {
          from {
            opacity: 0;
            transform: translateY(2rem);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-up {
          animation: fade-up 0.6s ease-out forwards;
        }
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }
        @keyframes gradient {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
        .animate-gradient {
          background-size: 200% auto;
          animation: gradient 3s ease infinite;
        }
      `}</style>
    </section>
  );
};

export default PrincipalMessage;